import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ICallbackAppState } from '../../../secure/common/i-callback-app-state';
import { UserLoginService } from '../../../service/user-login.service';

@Component({
  selector: 'app-auth-callback',
  templateUrl: './auth-callback.component.html',
  styleUrls: ['./auth-callback.component.scss'],
  standalone: false,
})
export class AuthCallbackComponent implements OnInit {
  public userService = inject(UserLoginService);
  public router = inject(Router);

  ngOnInit(): void {
    this.userService.auth.appState$.subscribe((appState: ICallbackAppState) => {
      let redirectUrl = appState?.redirectUrl;
      if (!redirectUrl) {
        redirectUrl = sessionStorage.getItem('post_login_redirect_app_state_expired') || null;
      }

      if (redirectUrl) {
        sessionStorage.removeItem('post_login_redirect_app_state_expired');
        window.location.href = redirectUrl;
      } else {
        this.router.navigateByUrl('/');
      }
    });
  }
}
